import { gql } from "@apollo/client";

export const ActivityInfoFragment = gql`
  fragment ActivityInfo on Activity {
    _id
    activity_date
    activity_trigger_action
    activity_trigger_action_data
    activity_source_UID
    activity_trigger_action_data_reason
    activity_trigger_source
    activity_source_context
    activity_trigger_by_user_id
    activity_updated_by {
      _id
      first_name
      last_name
      email
      phone_number
    }
  }
`;

